/** Shared number formatter (JP grouping per project convention — identical to
 *  en grouping: 10000 → "10,000"). Fractions keep at most one decimal, the
 *  precision the productivity figures carry. */
const FORMATTER = new Intl.NumberFormat('ja-JP', { maximumFractionDigits: 1 });

export function formatNumber(value: number): string {
  return FORMATTER.format(value);
}
